const LEGACY_PARTNER_ROLES = ['freddy_viewer', 'aj_viewer', 'matt_viewer'];

export const isPartnerRole = (role) => role === 'partner_viewer' || LEGACY_PARTNER_ROLES.includes(role);

export const ACCENT_DOT = {
  amber: 'bg-amber-500', indigo: 'bg-indigo-500', emerald: 'bg-emerald-500', rose: 'bg-rose-500',
  sky: 'bg-sky-500', violet: 'bg-violet-500', teal: 'bg-teal-500', orange: 'bg-orange-500',
};
